import { createUnifiedTheme, genPageTheme, palettes, pageTheme, UnifiedThemeProvider, defaultTypography } from '@backstage/theme';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';

const sulmaraLightPalette = {
  ...palettes.light,
  primary: {
    main: '#009639', // Bright Green
  },
  background: {
    default: '#FFFFFF', // White
    paper: '#F0F0F0', // Light Grey
  },
  banner: {
    info: '#0D1427', // Real Navy
    error: '#E22134',
    text: '#FFFFFF',
    link: '#009639',
  },
  errorBackground: '#E22134',
  warningBackground: '#FCE118', // Yellow
  infoBackground: '#1195AD', // Sea
  navigation: {
    ...palettes.light.navigation,
    background: '#0D1427', // Real Navy
    indicator: '#009639', // Bright Green
    color: '#FFFFFF',
    selectedColor: '#FFFFFF',
  },
};

const sulmaraDarkPalette = {
  ...palettes.dark,
  primary: {
    main: '#009639', // Bright Green
  },
  background: {
    default: '#0D1427', // Real Navy
    paper: '#0D1427', // Real Navy
  },

  banner: {
    info: '#0D1427', // Real Navy
    error: '#E22134',
    text: '#FFFFFF',
    link: '#009639',
  },
  errorBackground: '#E22134',
  warningBackground: '#FCE118', // Yellow
  infoBackground: '#1195AD', // Sea
  navigation: {
    ...palettes.dark.navigation,
    background: '#0D1427', // Real Navy
    indicator: '#009639', // Bright Green
    color: '#FFFFFF',
    selectedColor: '#FFFFFF',
  },
};

const customTypography = {
  ...defaultTypography,
  fontFamily: 'Helvetica, Arial, sans-serif',
  h1: { ...defaultTypography.h1, fontFamily: 'Helvetica, Arial, sans-serif' },
  h2: { ...defaultTypography.h2, fontFamily: 'Helvetica, Arial, sans-serif' },
  h3: { ...defaultTypography.h3, fontFamily: 'Helvetica, Arial, sans-serif' },
  h4: { ...defaultTypography.h4, fontFamily: 'Helvetica, Arial, sans-serif' },
  h5: { ...defaultTypography.h5, fontFamily: 'Helvetica, Arial, sans-serif' },
  h6: { ...defaultTypography.h6, fontFamily: 'Helvetica, Arial, sans-serif' },
};

const customPageTheme = {
  home: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.home.shape }),
  documentation: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.documentation.shape }),
  tool: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.tool.shape }),
  service: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.service.shape }),
  website: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.website.shape }),
  library: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.library.shape }),
  other: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.other.shape }),
  app: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.app.shape }),
  apis: genPageTheme({ colors: ['#0D1427', '#009639'], shape: pageTheme.apis.shape }),
};

export const sulmaraLightTheme = createUnifiedTheme({
  palette: sulmaraLightPalette,
  typography: customTypography,
  pageTheme: customPageTheme,
});

export const sulmaraDarkTheme = createUnifiedTheme({
  palette: sulmaraDarkPalette,
  typography: customTypography,
  pageTheme: customPageTheme,
});

export const sulmaraLightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Sulmara Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => <UnifiedThemeProvider theme={sulmaraLightTheme} children={children} />,
    },
  },
});

export const sulmaraDarkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Sulmara Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => <UnifiedThemeProvider theme={sulmaraDarkTheme} children={children} />,
    },
  },
});
